import { combineReducers } from 'redux';
import * as sessionReducers  from './session.js'
import * as userReducers  from './users.js'
import * as errorReducers  from './errors.js'
import * as webinarReducers  from './webinars.js'
import * as subscriptionReducers  from './subscriptions.js'
import * as vimeoReducers from './vimeo.js'
import * as modalReduces from './modal.js'
import * as quizReduceres from './quiz.js'
import * as suggestionReducers from './suggestions.js'
import * as requestReducers from './requests.js'
import * as sponsorsReducers from './sponsors.js';
import * as partnersReducers from './partners.js';
import * as landingReducers from './landing.js';
import * as disciplinesReducers from './disciplines';
import * as statsReducers from './stats';
import * as calendarReducers from './calendar';
import * as superhostsReducers from './superhosts';
import * as studygroupsReducers from './studygroups';
import * as zoomReducers from './zoom.js';
import * as clientUrlsReducers from './clientUrls.js';

import { reduxReactRouter, routerStateReducer, ReduxRouter } from 'redux-router';

const rootReducer = combineReducers({
  ...sessionReducers,
  ...userReducers,
  ...errorReducers,
  ...webinarReducers,
  ...subscriptionReducers,
  ...vimeoReducers,
  ...modalReduces,
  ...quizReduceres,
  ...suggestionReducers,
  ...requestReducers,
  ...sponsorsReducers,
  ...partnersReducers,
  ...landingReducers,
  ...disciplinesReducers,
  ...statsReducers,
  ...calendarReducers,
  ...superhostsReducers,
  ...studygroupsReducers,
  ...zoomReducers,
  ...clientUrlsReducers,
  router: routerStateReducer
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers/index.js